import { http } from '../rest';

export function fetchAdvisorAttestationTaskDetails(http, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetchAdvisorAttestationTaskDetails.data');
        data = file.default;
      } else {
        const response = await http.get('/get_current_advisor_attestation_history_details');
        data = response.data;
      }
      return data;
    },
  };
}

export default fetchAdvisorAttestationTaskDetails(http, process.env.DEMO);
